import React from "react";
import LoaderAnimation from "./LoaderAnimation";
import styles from "./Pageloader.module.css";

function CommonPageLoader({ load }) {
  return (
    <>
      {load ? (
        <div className={styles.loaderCover}>
          <div className={styles.loader}>
            <LoaderAnimation />
          </div>
        </div>
      ) : (
        ""
      )}
    </>
  );
}

export default CommonPageLoader;
